<div role="button" class="territoryCardBackOfCardContainer">
	<div class="territoryCardIconBackOfCard">
		<i [class]="'territoryCardIcon ' + fontAwesomeIconClass"></i>
	</div>
	<div class="territoryCardBackOfCardItemText">{{actionLabel}}</div>
</div>
